export default __webpack_public_path__ + "static/5-493237ac82659975bd33d6ee04bd4c7e.webp";